import React, { Component } from 'react';
import Body from './HTMLRender';
class MainText extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <Body text={this.props.text} />
            </div>
        )
    }
}

export default MainText;